import { useMemo } from 'react';
import { TowerModelDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useQueryListTowerModels } from '../../lockers.queries';
import { TowerModelUtils } from '../../logic/tower-model.utils';

/**
 * Hook that queries tower models and checks whether any of the given tower model names
 * correspond to a double-sided tower model.
 *
 * @param towerModelNames - Array of tower model name strings to check.
 * @returns Whether any tower in the list is double-sided, plus the tower models data.
 */
export function useHasDoubleSidedTower(towerModelNames: string[]): {
  hasDoubleSided: boolean;
  towerModels: TowerModelDto[];
} {
  const towerModelsResult = useQueryListTowerModels();
  const towerModels = towerModelsResult.data ?? [];

  const hasDoubleSided = useMemo(() => {
    return TowerModelUtils.hasDoubleSidedTower(towerModelNames, towerModels);
  }, [towerModelNames, towerModels]);

  return { hasDoubleSided, towerModels };
}
